import React from 'react';
import { Typography } from '@mui/material';

import CustomDialog from 'src/components/UI/dialog/CustomDialog';
import { useAutoTranslation } from 'src/hooks/useTranslate';

export default function ConfirmDeleteDialog({
  open,
  onClose,
  onConfirm,
  title = 'Delete',
  message,
  itemName
}) {
  const t = useAutoTranslation();

  return (
    <CustomDialog
      open={open}
      title={title}
      handleClose={onClose}
      showActions
      saveBtnLabel="Delete"
      cancelBtnLabel="Cancel"
      onSave={async () => onConfirm()}
      maxWidth="xs"
    >
      <Typography gutterBottom>{t(message)}</Typography>
      {itemName && (
        <Typography
          sx={{ fontWeight: 700, color: 'var(--color-navy, #1a3a5c)' }}
        >
          “{itemName}”
        </Typography>
      )}
    </CustomDialog>
  );
}
